/*eslint-disable */
const parserSlug = text => {
  return text.toString()
    .replace(/[A-Z]/g, m => "-" + m.toLowerCase());
}

export default parserSlug
